import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  items: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('items');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.items.length > 0 ? action.items : [];  
  return updateObject(state, {
    items: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, items:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ITEMS_START:
      return fetchStart(state);
    case actionTypes.FETCH_ITEMS_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_ITEMS_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
